import type { SVGProps } from 'react';

const SvgPortal = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M18 3.96H6c-1.65 0-3 1.35-3 3v3.42c0 .87.38 1.67 1 2.23v4.36c0 1.65 1.35 3 3 3h10c1.65 0 3-1.35 3-3v-4.36c.62-.56 1-1.36 1-2.23V6.96c0-1.65-1.35-3-3-3m-1 14H7c-.55 0-1-.45-1-1v-3.35l1.62.66a.998.998 0 1 0 .75-1.85l-2.75-1.11a.99.99 0 0 1-.62-.93V6.96c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v3.42c0 .41-.25.77-.62.93l-2.75 1.11c-.51.21-.76.79-.55 1.3.16.39.53.63.93.63.12 0 .25-.02.38-.07l1.62-.66v3.35c0 .55-.45 1-1 1z"
    />
    <path
      fill="currentcolor"
      d="M12 7.96c-1.1 0-2 .9-2 2 0 .74.4 1.38 1 1.72v2.28c0 .55.45 1 1 1s1-.45 1-1v-2.28c.6-.35 1-.98 1-1.72 0-1.1-.9-2-2-2"
    />
  </svg>
);
export default SvgPortal;
